import * as Immutable from 'immutable';
import {
  GET_DASHBOARD_PERFORMANCE_ABORTED,
  GET_DASHBOARD_PERFORMANCE_REQUESTED,
  GET_DASHBOARD_PERFORMANCE_COMPLETED,
  GET_DASHBOARD_PERFORMANCE_FAILED,
  SET_DASHBOARD_PERFORMANCE_FILTER_REQUESTED,
  SET_DASHBOARD_PERFORMANCE_FILTER_COMPLETED,
  SET_DASHBOARD_PERFORMANCE_FILTER_FAILED,
  RESET_DASHBOARD_PERFORMANCE_REQUESTED,
  RESET_DASHBOARD_PERFORMANCE_COMPLETED,
  // RESET_DASHBOARD_ASSETALLOCATION_REQUESTED,
  // RESET_DASHBOARD_ASSETALLOCATION_COMPLETED,
} from '../../actions/dashboardperformance/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: null,
  resettingdata: false,
  gettingdata: false,
  gotdata: false,
  settingfilter: false,
  setfilter: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_PERFORMANCE_ABORTED:
      return state.set('error', null).set('gettingdata', false);

    case GET_DASHBOARD_PERFORMANCE_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case GET_DASHBOARD_PERFORMANCE_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_DASHBOARD_PERFORMANCE_FAILED:
      return state.set('error', action.payload);
    case SET_DASHBOARD_PERFORMANCE_FILTER_REQUESTED:
      return state
        .set('error', null)
        .set('setfilter', false)
        .set('settingfilter', true);

    case SET_DASHBOARD_PERFORMANCE_FILTER_COMPLETED:
      return state
        .set('error', null)
        .set('settingfilter', false)
        .set('setfilter', true)
        .set('data', action.payload);

    case SET_DASHBOARD_PERFORMANCE_FILTER_FAILED:
      return state.set('error', action.payload);

    case RESET_DASHBOARD_PERFORMANCE_REQUESTED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('resettingdata', true)
        .set('gotdata', true);

    case RESET_DASHBOARD_PERFORMANCE_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('resettingdata', false)
        .set('data', null)
        .set('gotdata', true);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
